import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators/tap';

// OAuth2 Security - https://akveo.github.io/nebular/#/docs/auth/protecting-application-routes

@Injectable()
export class AuthGuardCrypto implements CanActivate {

  // constructor(private authService: NbAuthService) {
  // }
  //
  // canActivate() {
  //   // canActive can return Observable<boolean>, which is exactly what isAuhenticated returns
  //   return this.authService.isAuthenticated();
  // }

  constructor(private authService: NbAuthService, private router: Router) {
  }

  canActivate() {
    // console.log('[AuthGuardCrypto] authService.isAuthenticated' );
    // this.authService.getToken().toPromise().then(tokenX => {
    //   console.log('[AuthGuardCrypto] Token=' + JSON.stringify(tokenX));
    // });
    this.authService.getToken().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        localStorage.setItem('access_token', `Bearer ${token.getValue()}`); // save to local storage // TODO: Check
        // console.log('Token saved=' + localStorage.getItem('access_token'));
      }
    });
    return this.authService.isAuthenticated()
      .pipe(
        tap((authenticated) => {
          // console.log('[AuthGuardCrypto] Token=' + JSON.stringify(authenticated) + ',URL=' + this.router.url);
          if (!authenticated) {
            this.router.navigate([ 'auth/login' ]);
          }
        }),
      ); // So we just check the the value returened by isAuthenticated and simply redirect to the login page.
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/auth-crypto/auth-guard-crypto.service.ts